import { Component, OnInit } from '@angular/core';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { PartnerCodeInfoStepService } from '../../services/partner-code-info-step.service';

@Component({
  selector: 'app-partner-code-page',
  templateUrl: './partner-code-page.component.html',
  styleUrls: ['./partner-code-page.component.css']
})
export class PartnerCodePageComponent implements OnInit {

  constructor(
    private partnerCodeInfoStepService: PartnerCodeInfoStepService,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.partnerCodeInfoStepService.update();
    }
  }
}
